// extracted by mini-css-extract-plugin
export default {"server":"Server_server__KTZtB","deletePhraseButton":"Server_deletePhraseButton__bE0+w","serverOpacity":"Server_serverOpacity__aflHw","serverHidden":"Server_serverHidden__ZuD87"};